export function fixJumpingStickyHeaderCollapsible(
  previousStateCollapsedEl,
  collapsibleEl,
  prevStateScrollContainer,
  stickyPosition,
  offsetStickyPosition = 0
) {
  const prevStateStickyHeaderCollapsibleEl = previousStateCollapsedEl.querySelector(
    `[data-js-sticky-header]`
  );
  const headerOfCollapsibleWasSticky =
    prevStateStickyHeaderCollapsibleEl.getBoundingClientRect().top ===
    stickyPosition + offsetStickyPosition;

  const previousTopPosCollapsibleEl = previousStateCollapsedEl.getBoundingClientRect()
    .top;
  const prevScrollPosScrollContainer = prevStateScrollContainer.scrollTop;

  return {
    collapsibleEl,
    previousTopPosCollapsibleEl,
    prevScrollPosScrollContainer,
    headerOfCollapsibleWasSticky
  };
}

export function maintainScrollPositionCollapsible(scrollFixes, stickyPosition) {
  const { collapsibleEl, headerOfCollapsibleWasSticky } = scrollFixes;
  const collapsibleElToFix = collapsibleEl;
  if (collapsibleElToFix) {
    const topPositionCollapsible = collapsibleElToFix.getBoundingClientRect().top;
    if (topPositionCollapsible < stickyPosition || headerOfCollapsibleWasSticky) {
      return collapsibleElToFix.offsetTop;
    }
  }
  return false;
}

export function getScrollPositionToGetCollapsibleContentIntoView(
  collapsibleEl,
  offsetToView,
  scrollContainer
) {
  const collapsibleContentWrapper = collapsibleEl.querySelector(
    `[data-js-wrapper-listitem-collapsible-content]`
  );
  const collapsibleStickyHeader = collapsibleEl.querySelector('[data-js-sticky-header]');

  if (collapsibleContentWrapper) {
    const offsetFromBottomWindow =
      window.innerHeight -
      (collapsibleStickyHeader.getBoundingClientRect().y +
        collapsibleStickyHeader.getBoundingClientRect().height);

    if (offsetFromBottomWindow < offsetToView) {
      return scrollContainer.scrollTop + offsetToView - offsetFromBottomWindow;
    }
  }
  return false;
}

export function getDefaultAppScrollContainer() {
  return document.querySelector('*[data-container=appFrame]');
}

export function setScrollPositionAppContainer(
  topPosition,
  scrollContainer,
  smooth = false,
  leftPosition = 0
) {
  const scrollContainerOrDefault = scrollContainer || getDefaultAppScrollContainer();
  if (scrollContainerOrDefault) {
    scrollContainerOrDefault.scrollTo({
      left: leftPosition,
      top: topPosition,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }
}
